import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { RxRecommendationsResponse } from "../types";

interface UseGetRxRecommendationsParams {
  patientId: string;
  eocId?: string;
  partnerUid?: string;
  snomedCodes?: string[];
  enabled?: boolean;
}

export const useGetRxRecommendations = ({
  patientId,
  eocId,
  partnerUid,
  snomedCodes,
  enabled = true,
}: UseGetRxRecommendationsParams) => {
  const canonicalSnomedCodes = Array.from(new Set(snomedCodes ?? [])).sort();
  const hasSnomedFallbackParams = Boolean(
    partnerUid && canonicalSnomedCodes.length,
  );
  const queryKey = eocId
    ? QueryKeys.Patient.Chart.RxRecommendations.EOC({ patientId, eocId })
    : QueryKeys.Patient.Chart.RxRecommendations.SNOMED_CODES({
        patientId,
        partnerUid: partnerUid ?? "",
        snomedCodes: canonicalSnomedCodes,
      });

  return useApi<RxRecommendationsResponse>({
    queryOptions: {
      enabled: enabled && Boolean(eocId || hasSnomedFallbackParams),
      queryFn: async () => {
        const response = await axiosInstance.get<RxRecommendationsResponse>(
          "/rx/formulary/suggestions",
          {
            params: eocId
              ? { eocId }
              : { partnerUid, snomedCodes: canonicalSnomedCodes },
            paramsSerializer: { indexes: null },
          },
        );
        return response.data;
      },
      queryKey,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  });
};
